import { useEffect, useState } from 'react';
import { get, set } from '../services';

export function useSessionStoragePersistedState<T>(key: string, initialValue: T) {
	const [value, setValue] = useState<T>(() => {
		const item = get<T>(key);
		return (item as T) || initialValue;
	});
    
	useEffect(() => {
		if (value !== undefined) {
			set(key, value);
		}
	}, [value]);
    
	return [value, setValue] as const;
}